const OctoberJournal = [
    {
        url: "../images/HHER_Journal/October2024Journal/1.png",
        alt: "october-page-01"
    },
    {
        url: "../images/HHER_Journal/October2024Journal/2.png",
        alt: "october-page-02"
    },
    {
        url: "../images/HHER_Journal/October2024Journal/3.png",
        alt: "october-page-03"
    },
    {
        url: "../images/HHER_Journal/October2024Journal/4.png",
        alt: "october-page-04"
    },
    {
        url: "../images/HHER_Journal/October2024Journal/5.png",
        alt: "october-page-05"
    },
    {
        url: "../images/HHER_Journal/October2024Journal/6.png",
        alt: "october-page-06"
    },
    {
        url: "../images/HHER_Journal/October2024Journal/7.png",
        alt: "october-page-07"
    },
    {
        url: "../images/HHER_Journal/October2024Journal/8.png",
        alt: "october-page-08"
    },
    {
        url: "../images/HHER_Journal/October2024Journal/9.png",
        alt: "october-page-09"
    },
    {
        url: "../images/HHER_Journal/October2024Journal/10.png",
        alt: "october-page-10"
    },
    {
        url: "../images/HHER_Journal/October2024Journal/11.png",
        alt: "october-page-11"
    },
    {
        url: "../images/HHER_Journal/October2024Journal/12.png",
        alt: "october-page-12"
    },
    {
        url: "../images/HHER_Journal/October2024Journal/13.png",
        alt: "october-page-13"
    },
    {
        url: "../images/HHER_Journal/October2024Journal/14.png",
        alt: "october-page-14"
    },
    {
        url: "../images/HHER_Journal/October2024Journal/15.png",
        alt: "october-page-15"
    },
    {
        url: "../images/HHER_Journal/October2024Journal/16.png",
        alt: "october-page-16"
    },
    {
        url: "../images/HHER_Journal/October2024Journal/17.png",
        alt: "october-page-17"
    },
    {
        url: "../images/HHER_Journal/October2024Journal/18.png",
        alt: "october-page-18"
    },
    {
        url: "../images/HHER_Journal/October2024Journal/19.png",
        alt: "october-page-19"
    },
    {
        url: "../images/HHER_Journal/October2024Journal/20.png",
        alt: "october-page-20"
    },
    {
        url: "../images/HHER_Journal/October2024Journal/21.png",
        alt: "october-page-21"
    },
    {
        url: "../images/HHER_Journal/October2024Journal/22.png",
        alt: "october-page-22"
    },
    {
        url: "../images/HHER_Journal/October2024Journal/23.png",
        alt: "october-page-23"
    },
    {
        url: "../images/HHER_Journal/October2024Journal/24.png",
        alt: "october-page-24"
    },
    {
        url: "../images/HHER_Journal/October2024Journal/25.png",
        alt: "october-page-25"
    },
    {
        url: "../images/HHER_Journal/October2024Journal/26.png",
        alt: "october-page-26"
    },
    {
        url: "../images/HHER_Journal/October2024Journal/27.png",
        alt: "october-page-27"
    },
    {
        url: "../images/HHER_Journal/October2024Journal/28.png",
        alt: "october-page-28"
    }
];

export default OctoberJournal;